import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=5fb12ae2&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=5fb12ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb12ae2",
  null
  
)

export default component.exports